

export const WIZARBIT_TAG_ID = "G-WL79T27NHR"
export const PROMO_TAG_ID = "G-PEY2QTM338"
export const LANDING_TAG_ID = "G-JWW06F1Z2C"